export const ERROR_GREET_LIMIT_ALERT = "Greeting is too long";
export const ERROR_GREET_LIMIT_ALERT_REASON =
  "Greeting should be less than 160 characters";
export const EMOJIS_NOT_ALLOWED_ALERT = "Emojis are not allowed";
